import classNames from 'clsx';
import { ReactComponent as AppQRCode } from 'img/errors/app-qrcode.svg';
import { ReactComponent as CuteCat } from 'img/errors/cute-cat.svg';
import React, { FC, memo } from 'react';
import { DisableButtonComponent } from 'reactApp/ui/AdvBanners/DisableButton/DisableButtonComponent';
import { DownloadAppButtonComponent } from 'reactApp/ui/Mobile/DownloadAppButton/DownloadButtonComponent';
import { ON_PREMISE } from 'server/constants/environment';

import { ErrorPageButton } from './components/ErrorPageButton';
import styles from './ErrorPage.css';
import { disableAdvButtonHref, ERROR_STATUS_MAP } from './ErrorPage.helpers';
import { ErrorInfo, EStatus, IProps } from './ErrorPage.types';

export const ErrorPageComponent: FC<Omit<IProps, 'status'> & ErrorInfo & { status: EStatus | string }> = ({
    status,
    title,
    annotation,
    buttonLink,
    buttonText,
    imageSrc,
    downloadLink,
    onButtonClick,
    advDomIdDesktop,
    children,
}) => (
    <div className={styles.container} data-qa-id={status}>
        <div className={styles.wrapper}>
            <div className={styles.root}>
                <img className={styles.error} src={imageSrc} />
                <div className={styles.description}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.annotation}>{annotation}</div>
                    <ErrorPageButton link={buttonLink} text={buttonText} onClick={onButtonClick} />
                </div>
            </div>

            {!ON_PREMISE && (
                <>
                    <div className={styles.downloadAppContainer}>
                        <div className={styles.cuteCat}>
                            <CuteCat />
                        </div>
                        <div className={styles.qrcodeContainer}>
                            <div className={styles.qrcode}>
                                <AppQRCode />
                            </div>
                            <div className={styles.qrcodeText}>
                                Установите приложение, чтобы ваши файлы и&nbsp;фото всегда были под рукой
                            </div>
                        </div>
                    </div>

                    <div className={styles.appButton}>
                        <DownloadAppButtonComponent linkToDownload={downloadLink} text="Установить приложение" showIcon />
                    </div>
                </>
            )}
        </div>
        {!ON_PREMISE && (
            <div className={styles.advDesktop}>
                {children || (
                    <div className={classNames(styles.advHeaderStatic, 'js-header-error-page')}>
                        <h3 className={styles.advTitle}>Реклама</h3>
                        <DisableButtonComponent className="js-disable-button" text="Отключить" href={disableAdvButtonHref} />
                    </div>
                )}
                <div id={advDomIdDesktop} data-qa-id="Sidebar" />
            </div>
        )}
    </div>
);

export const ErrorPageBlock = memo<IProps>((props) => {
    const { status } = props;
    const info = ERROR_STATUS_MAP[status];

    return <ErrorPageComponent {...props} {...info} />;
});

ErrorPageBlock.displayName = 'ErrorPageBlock';
